import { render, staticRenderFns } from "./Personalise.vue?vue&type=template&id=a94beada&"
import script from "./Personalise.vue?vue&type=script&lang=js&"
export * from "./Personalise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a94beada')) {
      api.createRecord('a94beada', component.options)
    } else {
      api.reload('a94beada', component.options)
    }
    module.hot.accept("./Personalise.vue?vue&type=template&id=a94beada&", function () {
      api.rerender('a94beada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Personalise.vue"
export default component.exports